var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1875 2.14719C11.4993 1.95625 11.8904 1.95071 12.2075 2.13275L21.4979 7.46608C21.8085 7.64439 22 7.97519 22 8.33333V19C22 19.5523 21.5523 20 21 20H3C2.44772 20 2 19.5523 2 19V8.33333C2 7.98529 2.18097 7.66228 2.47778 7.48052L11.1875 2.14719ZM11.7261 4.16251L4 8.89358V18H20V8.91232L11.7261 4.16251Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 12C7.25 11.5858 7.58579 11.25 8 11.25H16C16.4142 11.25 16.75 11.5858 16.75 12V19C16.75 19.4142 16.4142 19.75 16 19.75H8C7.58579 19.75 7.25 19.4142 7.25 19V12ZM8.75 12.75V18.25H15.25V12.75H8.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.43557 11.5061C7.70833 11.1944 8.18215 11.1628 8.49388 11.4356L12 14.5034L15.5061 11.4356C15.8178 11.1628 16.2917 11.1944 16.5644 11.5061C16.8372 11.8178 16.8056 12.2917 16.4939 12.5644L13.1389 15.5L16.4939 18.4356C16.8056 18.7083 16.8372 19.1822 16.5644 19.4939C16.2917 19.8056 15.8178 19.8372 15.5061 19.5644L12 16.4966L8.49388 19.5644C8.18215 19.8372 7.70833 19.8056 7.43557 19.4939C7.16281 19.1822 7.19439 18.7083 7.50612 18.4356L10.8611 15.5L7.50612 12.5644C7.19439 12.2917 7.16281 11.8178 7.43557 11.5061Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarn);
export default __webpack_public_path__ + "static/media/barn.58134d86779c8ebaa2935065306910e1.svg";
export { ForwardRef as ReactComponent };